import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import Messages from "../../../constants/Messages";
import handleError from "../../../constants/handleError";
import { SendIcon, XIcon } from '../../../constants/Icons';

const AddSubStore = ({ isOpen, onClose, }) => {

    const [title, setTitle] = useState("");
    const [email, setEmail] = useState("");
    const [shops, setShops] = useState([]);
    const [isBtnLoading, setBtnLoading] = useState(false);
    const [error, setErrors] = useState({});
    const storeTitleRef = useRef(null);
    const storeEmailRef = useRef(null);
    const buttonRef = useRef(null)

    const { checkNetwork } = useNetwork();
    const showAlert = useShowAlert();
    const navigate = useNavigate();

    if (!isOpen) return null;

    const validateForm = () => {
        const errors = {};
        if (!title) {
            errors.title = Messages.ERROR.EMPTY_TITLE;
        } else if (!/^[a-zA-Z0-9\s]+$/.test(title)) {
            errors.title = Messages.ERROR.INVALID_EMAIL;
        }
        else if (!email) {
            errors.email = Messages.ERROR.EMPTY_EMAIL;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            errors.email = Messages.ERROR.INVALID_EMAIL;
        }
        setErrors(errors);
        if (Object.keys(errors).length > 0) {
            const firstErrorField = Object.keys(errors)[0];
            switch (firstErrorField) {
                case 'title':
                    storeTitleRef.current?.focus();
                    break;
                case 'email':
                    storeEmailRef.current?.focus();
                    break;
                default:
                    break;
            }
        }
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!validateForm()) return;
        handleAdd();
    };

    const handleAdd = async () => {
        setBtnLoading(true);
        try {
            if (!checkNetwork()) return;
            const response = await AxiosInstance.post(`add-substore`, { title: title, email: email });
            handleClose();
            setShops([...shops, response.data]);
            setBtnLoading(false);
            showAlert("success", Messages.SUCCESS.INVITATION_SEND);
        } catch (error) {
            handleError(error, showAlert);
            return false;
        } finally {
            setBtnLoading(false);
        }
    };

    const handleClose = () => {
        setTitle("")
        setEmail("")
        setErrors({});
        onClose();
    };

    const handleEnterFocus = (e, nextRef) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          if((e.target === storeTitleRef.current && !title.trim()) || (e.target === storeEmailRef.current && !email.trim())){
            if(!validateForm()) return;
          }
          nextRef?.current?.focus();
        }
      };

    const stopEventPropagation = (e) => e.stopPropagation();

    return (
        <div>
            <div className="modal-backdrop show"></div>
            <div
                className="modal show"
                id="StoreModal"
                tabIndex="0"
                aria-modal="true"
                role="dialog"
                style={{ display: "block" }}
            >

                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                    onClick={stopEventPropagation}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title">Add Outlet</h6>
                            <button type="button" className="btn-close" onClick={handleClose} data-bs-dismiss="modal" aria-label="Close" fdprocessedid="jgxcje"></button>
                        </div>
                        <div className="modal-body bg-light">
                            <div className="card mb-0">
                                <div className="card-body">
                                    <div className="row g-3">
                                        <div className="col-lg-12">
                                            <label htmlFor="title" className="form-label">Title <span className="text-danger">*</span></label>
                                            <input type="text"
                                                className="form-control"
                                                title="title"
                                                autoComplete="off"
                                                value={title}
                                                onKeyDown={(e)=>handleEnterFocus(e,storeEmailRef)}
                                                onChange={(e) => setTitle(e.target.value)}
                                                ref={storeTitleRef}
                                                autoFocus
                                            />
                                            {error.title && (
                                                <div className="error-message invalid-feedback" >
                                                    {error.title}
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-lg-12">
                                            <label htmlFor="email" className="form-label">Email <span className="text-danger">*</span></label>
                                            <input type="text"
                                                className="form-control"
                                                autoComplete="off"
                                                value={email}
                                                ref={storeEmailRef}
                                                onKeyDown={(e)=>handleEnterFocus(e,buttonRef)}
                                                onChange={(e) => setEmail(e.target.value)}
                                                name="email" />

                                            {error.email && (
                                                <div className="error-message invalid-feedback" >
                                                    {error.email}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="modal-footer d-block">
                            <button type="button" className="btn btn-outline-secondary text-left" onClick={handleClose}>
                                <XIcon/> Cancel
                            </button>
                            {isBtnLoading ? (
                                <button className="btn btn-primary pb-0 text-right" disabled>
                                    <CircularProgress size={22} className="text-white" />
                                </button>
                            ) : (
                                <button ref={buttonRef} type="button" className="btn btn-primary text-right"
                                    onClick={handleSubmit}>
                                    <SendIcon/> Send Invitation
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

AddSubStore.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onAdd: PropTypes.func.isRequired,
};

export default AddSubStore;